import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=16d2b536&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=16d2b536&prod&scoped=true&lang=css"
import style1 from "./CreateOrder.vue?vue&type=style&index=1&id=16d2b536&prod&lang=css"
import style2 from "./CreateOrder.vue?vue&type=style&index=2&id=16d2b536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2b536",
  null
  
)

export default component.exports